import { render, staticRenderFns } from "./TablePivotPropsToSet.vue?vue&type=template&id=63d5bb62&"
import script from "./TablePivotPropsToSet.vue?vue&type=script&lang=js&"
export * from "./TablePivotPropsToSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports